import { render, staticRenderFns } from "./FormConfigLivros.vue?vue&type=template&id=3ff8da6c&"
import script from "./FormConfigLivros.vue?vue&type=script&lang=js&"
export * from "./FormConfigLivros.vue?vue&type=script&lang=js&"
import style0 from "./FormConfigLivros.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports